export default class ShareYourVisionStoryUploadForm {
  constructor(el) {
    this.el = el;

    if (!this.el) {
      return false;
    }

    this.fileField = this.el.querySelector('input[name="file"]');
    this.fileUrlField = this.el.querySelector(
      'input[id="share_your_vision_story_file_url'
    );
    this.submitButton = this.el.querySelector('button[type="submit"]');
    this.submittable = false;
    this.dropzone = this.el.querySelector('[data-dropzone]');
    this.uploading = this.el.querySelector('[data-uploading]');
    this.done = this.el.querySelector('[data-done]');
    this.uploadingFilename = this.el.querySelector('[data-uploading-filename]');
    this.doneFilename = this.el.querySelector('[data-done-filename]');
    this.remove = this.el.querySelector('[data-remove]');

    this.init();
  }

  init() {
    this.fileField.addEventListener('change', (event) => {
      this.file = event.target.files[0];
      this.getPresignedUrl();
    });

    this.dropzone.addEventListener('click', (event) => {
      event.preventDefault();
      this.fileField.click();
    });

    this.dropzone.addEventListener('dragover', (event) => {
      event.preventDefault();
      this.dropzone.classList.add('-dragover');
    });

    this.dropzone.addEventListener('dragleave', (event) => {
      event.preventDefault();
      this.dropzone.classList.remove('-dragover');
    });

    this.dropzone.addEventListener('drop', (event) => {
      event.preventDefault();
      this.file = event.dataTransfer.files[0];
      this.getPresignedUrl();
    });

    this.remove.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.uploading.classList.remove('-active');
      this.done.classList.remove('-active');
      this.fileUrlField.value = null;
      this.submittable = false;
    });
  }

  async getPresignedUrl() {
    const csrf_token = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content');

    const location = '/shareyourvision/share-your-story/presign';
    const data = {
      content_type: this.file.type,
    };

    const settings = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrf_token,
      },
      body: JSON.stringify(data),
    };

    try {
      const fetchResponse = await fetch(location, settings);
      this.presignedPost = await fetchResponse.json();
      this.uploading.classList.add('-active');
      this.uploadingFilename.innerHTML = this.file.name;

      try {
        await this.uploadFile();
        this.uploading.classList.remove('-active');
        this.done.classList.add('-active');
        this.doneFilename.innerHTML = this.file.name;
      } catch (e) {
        console.log(e);
        this.uploading.classList.remove('-active');
      }
    } catch (e) {
      console.log(e);
      this.uploading.classList.remove('-active');
      this.done.classList.remove('-active');
    }
  }

  async uploadFile() {
    const location =
      'https://' + this.presignedPost['bucket_name'] + '.s3.amazonaws.com';

    let formData = new FormData();

    // Do not change the order of these fields
    // For some reason S3 wants `file` to be last and `key` to be early in the request
    formData.append('key', this.presignedPost['key']);
    formData.append('acl', this.presignedPost['acl']);
    formData.append('policy', this.presignedPost['policy']);
    formData.append('x-amz-credential', this.presignedPost['x-amz-credential']);
    formData.append('x-amz-signature', this.presignedPost['x-amz-signature']);
    formData.append('x-amz-algorithm', this.presignedPost['x-amz-algorithm']);
    formData.append('x-amz-date', this.presignedPost['x-amz-date']);
    formData.append(
      'success_action_status',
      this.presignedPost['success_action_status']
    );
    formData.append('Content-Type', this.file.type);
    formData.append('file', this.file, this.file.name);

    const settings = {
      method: 'POST',
      body: formData,
    };
    try {
      const fileUploadResponse = await fetch(location, settings);
      fileUploadResponse.text().then((text) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(text, 'text/xml');
        const location = xmlDoc.getElementsByTagName('Location')[0].textContent;
        console.log(location);
        this.fileUrlField.value = location;
        this.submittable = true;
        this.submitButton.removeAttribute('disabled');
      });
    } catch (e) {
      console.log(e);
    }
  }
}

const form = document.querySelector('#ShareYourVisionStoryUploadForm');
if (form) {
  new ShareYourVisionStoryUploadForm(form);
}
